"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const alchemy_ui_1 = require("@m/alchemy-ui");
const FormPublishSwitcher = (props) => {
    const { displayedVersion, changeDisplayedVersion } = props;
    const handlePublishState = (value) => {
        changeDisplayedVersion(value);
    };
    return (react_1.default.createElement(alchemy_ui_1.SegmentedControl, { role: "radiogroup", activeControlValue: displayedVersion, onControlChange: ({ value }) => handlePublishState(value), controls: [
            { label: 'Draft', value: 'draft', id: 'switch-draft' },
            { label: 'Published', value: 'published', id: 'switch-published' }
        ] }));
};
exports.default = FormPublishSwitcher;
